export default function Footer() {
  return (
    <footer className="hb-footer">
      <div className="hb-footer__rewind">BE KIND, REWIND</div>
      <div className="hb-footer__line">
        Home Blockbuster · Data courtesy of <a href="https://www.themoviedb.org/" rel="noreferrer noopener" target="_blank">TMDB</a>
      </div>
    </footer>
  );
}
